
import { defineComponent, ref } from 'vue';
import { useApi2 } from '@/hooks/useApi2';
import { formatListingRequest, useActiveTable } from '@/components/activeTable/useActiveTable';
import { ApiCommand } from '@/store/modules/api';
import { formatDate } from '@/utils/date';

export type UpdatesVersion = {
  id: number;
  version_backend: string;
  version_frontend: string;
  title: string;
  text_backend: string;
  text_frontend: string;
  created_at: string;
  updated_at: string;
  published_at: string;
}

export default defineComponent({
  setup() {
    const request = useApi2();

    const {
      records,
    } = useActiveTable<UpdatesVersion, UpdatesVersion, 'id'>({
      defaultLimit: ref(1000),
      keyField: 'id',
      async fetch({ params, signal }) {
        const response = await request({
          command: ApiCommand.updatesGetList,
          params: formatListingRequest(params),
        });
        return response.response;
      },
    });

    return {
      records, formatDate,
    };
  },
});
